const INDENT = -35
const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth
export const getRightPositionOfCustomButton = () => INDENT + getScrollbarWidth()
